// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentMedBenEnrollmentUpdateRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentMedBenEnrollmentUpdateRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentMedBenEnrollmentUpdateRequestModel.discriminator = undefined;
ExtEnrollmentMedBenEnrollmentUpdateRequestModel.additionalProperties = false;
ExtEnrollmentMedBenEnrollmentUpdateRequestModel.attributeTypeMap = [
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "ExtEnrollmentMedBenClientIdentifiersModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "ExtEnrollmentMedBenEnrollmentDemographicsModel"
    },
    {
        "name": "guardianInfo",
        "baseName": "guardianInfo",
        "type": "ExtEnrollmentGuardianInfoModel"
    },
];
//# sourceMappingURL=extEnrollmentMedBenEnrollmentUpdateRequestModel.js.map